import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef, GridRowId } from '@mui/x-data-grid';
import PersonIcon from '@mui/icons-material/Person';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

import { FDataGrid, FDataGridToolbarAction } from '../grid';
import { PlanningCycleRow } from './planningCycle.models';

type Props = {
  rows: any[];
  //rows: PlanningCycleRow[];
  loading?: boolean;
  selectedRowId?: GridRowId | null;
  //onSelect: (row: PlanningCycleRow) => void;
  onSelect: (row: any | null) => void;
  onOpenWorkspace: () => void;
  onSetCurrentContext: () => Promise<void> | void;
};

class PlanningCycleGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'code', headerName: 'Cycle', width: 210 },
    { field: 'name', headerName: 'Name', flex: 1, minWidth: 260 },
    { field: 'budgetperiodcode', headerName: 'Budget Period', width: 160 },
    { field: 'fiscalyear', headerName: 'Fiscal Year', width: 110 },
    { field: 'phasecode', headerName: 'Current Phase', width: 210 },
    {
      field: 'statecode',
      headerName: 'State',
      width: 130,
      renderCell: (p) => (
        <Chip
          size="small"
          label={p.value || '-'}
          color={p.value === 'ACTIVE' ? 'success' : p.value === 'CLOSED' ? 'default' : 'warning'}
        />
      ),
    },
    { field: 'periodstartdate', headerName: 'Starts', width: 120 },
    { field: 'periodenddate', headerName: 'Ends', width: 120 },
  ];

  render() {
    const toolbarActions: FDataGridToolbarAction[] = [
      {
        key: 'workspace',
        label: 'Setup',
        icon: <SettingsSuggestIcon />,
        disabled: !this.props.selectedRowId,
        onClick: this.props.onOpenWorkspace 
      },
      {
        key: 'context',
        label: 'Set Default',
        icon: <PersonIcon />,
        disabled: !this.props.selectedRowId,
        onClick: this.props.onSetCurrentContext
      }
      ]
    return (
      <FDataGrid
        title="Planning Cycles"
        subtitle="Budget-domain planning exercises and their current lifecycle phase."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={500}

        showQuickFilter
        masterDetail
        showSelectionControl
        selectedRowId={this.props.selectedRowId}
        onSelectedRowChange={(row) => this.props.onSelect(row)}

        enableCsvExport
        enablePrintExport={false}
        csvFileName="Planning_Cycles"
        csvUtf8WithBom

        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={(r: any) => r.rid}
        onRowClick={(p: any) => this.props.onSelect(p.row)}
        pageSizeOptions={[10, 25, 50]}
        toolbarActions={toolbarActions}
      />

      // <FDataGrid
      //   title="Planning Cycles"
      //   subtitle="Select one cycle to display its lifecycle details."
      //   rows={this.props.rows}
      //   columns={this.columns}
      //   loading={this.props.loading}
      //   height={500}

      //   masterDetail
      //   showSelectionControl
      //   selectedRowId={
      //     this.props.selectedRowId
      //   }
      //   onSelectedRowChange={(row) =>
      //     this.props.onSelect(row)
      //   }

      //   showQuickFilter
      //   enableCsvExport
      //   enablePrintExport={false}
      //   csvFileName="Planning_Cycles"
      //   csvUtf8WithBom

      //   getRowId={(row) => row.rid}
      //   pageSizeOptions={[
      //     10,
      //     25,
      //     50,
      //   ]}
      // />
    );
  }
}

export default PlanningCycleGrid;
